// WP0 Task 1 — the binding terminology glossary (spec §7; MASTER global
// constraint). One noun per concept, rendered VERBATIM on every surface so a
// rename is a one-line change here, not a 40-file grep. Import-free leaf
// (node:test-able) per the @pageboss/shared charter.

/** Customer-facing nouns. Never hand-write these words on a surface. */
export const TERMS = {
  /** The Google listing. Never "GBP" or "Google Business Profile" in UI copy
   *  (inventory 04 §4 found three coexisting names). */
  googleProfile: 'Google Profile',
  /** The tracked query unit. Never "keywords" in UI copy — the API field
   *  stays `keywords` per locked decision #21. */
  searchTerms: 'search terms',
  /** AI-engine visibility. Never "LLM answers" / "AI search results". */
  aiAnswers: 'AI answers',
} as const;
export type TermKey = keyof typeof TERMS;

/** The four layers — lowercase everywhere: marketing narrative, wizard steps,
 *  panel nav, weekly report (spec §3). Order is canonical and load-bearing
 *  (wizard step order, overview row order, /system nav order). */
export const LAYERS = ['foundation', 'visibility', 'reputation', 'pulse'] as const;
export type LayerKey = (typeof LAYERS)[number];

/** One-line layer descriptions shared by marketing /system pages, panel layer
 *  landings and wizard step subtitles. Lowercase brand voice. */
export const LAYER_TAGLINES: Record<LayerKey, string> = {
  foundation:
    'your business info, your website, your domain and mailboxes — the ground everything stands on.',
  visibility: `your ${TERMS.googleProfile}, your ${TERMS.searchTerms} on the map, and where you show up in ${TERMS.aiAnswers}.`,
  reputation: 'reviews, reply drafts you approve, and rules that keep every ask compliant.',
  pulse: 'the messages, leads and analytics your presence produces every week.',
};

/** Reports is a menu section and the system's proof — NOT a marketing layer
 *  (spec §3/§7). Exported so nav code never invents a variant label. */
export const REPORTS_SECTION = 'reports' as const;
